module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARBAMAAADJQ1rJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTJiYmJiYmJiYmJubm5iYmJqampmZmZmZmZiYmJmZmZmZmRPCW2QAAAALdFJOUwDvoigPQl+/b9WArsbAtQAAAGpJREFUCNdjYIAAtgAog0EbxmLa7QAT2g0VY9u9OwHCMty9WwHCqoaxOHbvFgVRwgyOu3cCtTJXb2JYvXsKUGj17t3BuzeCTDPavbtotzBYeeLu3bsbwCxm6d2boDZZ7haBslik4S4yApMA9mcc1HfpTtYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/arrowIcon.png
// module id = 1652
// module chunks = 5